import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OnInit} from '@angular/core';
import {SafeSubscriberDirective} from '../../../../../../../application/app-context/safe-subscriber.directive';
import {WidgetDetail} from '../../../../../../../domain/widget/model/widget-detail';
import {BankProposal} from '../../../../../../../domain/bank-proposal/bank-proposal';
import {TranslateService} from '@ngx-translate/core';
import {HomeAssistanceListDialogComponent} from '../../../../assistance/list-dialog/home-assistance-list-dialog.component';
import {UserContextService} from '../../../../../../../application/app-context/user-context/user-context.service';
import {DomainUrlService} from '../../../../../../../application/config/domain-url.service';
import {ApplicationName} from '../../../../../../../domain/core/model/aplication-name.enum';
import {MatDialog} from '@angular/material/dialog';

@Component({
             selector: 'app-widget-bankproposal-large',
             templateUrl: './home-dashboard-widget-bankproposal-large.component.html'
           })
export class HomeDashboardWidgetBankproposalLargeComponent extends SafeSubscriberDirective implements OnInit {

  @Input() widget: WidgetDetail | undefined;
  @Input() bankProposalData: BankProposal | undefined;
  @Input() dashboardId: number | undefined;

  @Output() actionEvent = new EventEmitter<string>();

  isAssistanceEnabled: boolean;
  insitoAccountId: number;

  constructor(public matDialog: MatDialog,
              public translateService: TranslateService,
              private userContextService: UserContextService,
              private domainUrlService: DomainUrlService) {
    super();
  }

  ngOnInit(): void {
    const userContext = this.userContextService.getUserContext();
    this.isAssistanceEnabled = userContext.isAssistanceEnabled;
    this.insitoAccountId = userContext.getCurrentAccount().applications.find(application => application.targetApp === ApplicationName.INSITO && application.hasAccess).accountSynchId;
  }

  displayRate(rate: number): string {
    if (rate == null) {
      return '-';
    }
    const rateRounded = rate.toFixed(2);
    return rateRounded + '%';
  }

  displayDifferential(rate: number, previousRate: number): string {
    if (rate == null || previousRate == null) {
      return '-';
    }
    const differential = rate - previousRate;
    if (differential > 0) {
      return '+' + differential.toFixed(2);
    }
    return differential.toFixed(2);
  }

  resolveTrend(rate: number, ratePrevious: number): string {
    if (rate == null || ratePrevious == null) {
      return '';
    }
    const trendValue = rate - ratePrevious;
    if (trendValue > 0) {
      return 'fa-arrow-alt-circle-up c-alert';
    } else if (trendValue < 0) {
      return 'fa-arrow-alt-circle-down c-success';
    } else {
      return 'fa-arrow-alt-circle-right c-gray';
    }

  }

  redirectToAssistance(): void {
    this.actionEvent.emit('widget.bank-proposal.discover-opportunity');
    this.matDialog.open(HomeAssistanceListDialogComponent, {
      data: {
        searchText: this.translateService.instant('widget.bank-proposal.search-opportunity')
      },
      height: '100%',
      width: '75%',
      position: {
        right: '0'
      }
    });
  }

  redirectToInsitoIfHasAccessOrElseBankProposal(): void {
    if (this.insitoAccountId !== undefined) {
      window.location.href = `${this.domainUrlService.getInsitoUrl()}?accountId=${this.insitoAccountId}&redirectLink=analysesEtSyntheses`;
      return;
    }
    window.location.href = `${this.domainUrlService.getBankProposalUrl()}/dashboard`;
  }

}
